module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/polymer/paper-item/paper-item.component.html
// module id = ./src/app/components/polymer/paper-item/paper-item.component.html
// module chunks = main